import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { SocialProofSection } from './components/SocialProofSection';
import { DiagnosticoSection } from './components/DiagnosticoSection';
import { CuraSection } from './components/CuraSection';
import { ProcesoSection } from './components/ProcesoSection';
import { GarantiaSection } from './components/GarantiaSection';
import { ContactForm } from './components/ContactForm';
import { CtaFinal } from './components/CtaFinal';
import { Footer } from './components/Footer';
export function App() {
  return <main className="min-h-screen bg-brand-black text-white selection:bg-brand-green/30 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <SocialProofSection data-id="element-3" />
      <div id="diagnostico" data-id="element-4">
        <DiagnosticoSection data-id="element-5" />
      </div>
      <div id="la-cura" data-id="element-6">
        <CuraSection data-id="element-7" />
      </div>
      <ProcesoSection data-id="element-8" />
      <GarantiaSection data-id="element-9" />
      <ContactForm data-id="element-10" />
      <CtaFinal data-id="element-11" />
      <Footer data-id="element-12" />
    </main>;
}